import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.prompt') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.prompt') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.prompt') })
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.prompt') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.prompt') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.prompt') })
});
